import { io } from 'socket.io-client';

let socketInstance;

export const getSocket = () => {
  if (!socketInstance) {
    if (!process.env.REACT_APP_BACKEND) {
      throw new Error('REACT_APP_BACKEND is not configured.');
    }

    socketInstance = io(process.env.REACT_APP_BACKEND, {
      transports: ['websocket', 'polling'],
    });
  }

  return socketInstance;
};
